import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ApolloProvider } from '@apollo/client';
import OpenEndedCoding from './OpenEndedCoding';
import { setApolloClient } from './graphql-client';
import { OpenEndedCodingProvider } from './Context';
import { OECRetrainStepProgress, OECDiscardKeywordGenerationModal, OECDiscardKeywordsModal, SORT_BY, TRAINING_STEP, FILTER_BY_TAGGED_STATUS } from './types';
import { USE_CASES } from './constants';
import { ThemeProvider } from 'react-jss';
import { WrenchTheme } from '@wds/styles';
export const OpenEndedCodingWrapper = props => {
  const values = {
    isSolutions: props.isSolutions,
    surveyId: props.surveyId,
    questionId: props.questionId,
    themes: [],
    responses: [],
    keywords: [],
    stimuli: props.stimuli ? props.stimuli : [],
    showTrainingScreen: false,
    showSA: false,
    responsesPage: 0,
    responsesCount: 0,
    totalResponsesCount: 0,
    autotaggingPredictionId: props.predictionId,
    error: false,
    shouldRefetchOnOpen: false,
    // state for filters
    searchInput: '',
    sortValue: SORT_BY.DATE,
    filterByTaggedStatus: FILTER_BY_TAGGED_STATUS.ALL,
    filterDisabled: false,
    selectedThemes: [],
    selectedSentiment: [],
    selectedStimuli: props.stimuli ? props.stimuli.map(({
      id
    }) => id) : [],
    // state for training
    trainingStep: TRAINING_STEP.KEYWORD_GENERATION,
    unsavedKeywords: [],
    keywordPredictionId: null,
    generatedKeywords: [],
    jobId: props.jobId ? props.jobId : null,
    summaryCounts: null,
    showTrainingErrorToast: false,
    trainingStatus: props.autotrainingStatus,
    showDiscardKeywordGenerationModal: OECDiscardKeywordGenerationModal.HIDE_KEYWORDS_MODAL,
    showDiscardKeywordsModal: OECDiscardKeywordsModal.HIDE_KEYWORDS_MODAL,
    // retraining state
    initialThemes: [],
    notEnoughThemesCreatedStep: OECRetrainStepProgress.HIDE_STEP,
    showUpdateAutotaggingModal: false,
    updateAutotaggingModalSeenCount: 0,
    // themes reuse state
    previouslyUsedThemes: [],
    suggestedThemes: {},
    useCases: Object.keys(USE_CASES),
    selectedUseCase: null,
    selectedReusedThemes: []
  };
  const {
      includeClient,
      clientConfig
    } = props,
    actualProps = __rest(props, ["includeClient", "clientConfig"]);
  const oecApp = _jsx(ThemeProvider, {
    theme: WrenchTheme,
    children: _jsx(OpenEndedCodingProvider, {
      values: values,
      children: _jsx(OpenEndedCoding, Object.assign({}, actualProps))
    })
  });
  // include client
  if (includeClient && !!clientConfig) {
    const apolloClient = setApolloClient(clientConfig);
    return _jsx(ApolloProvider, {
      client: apolloClient,
      children: oecApp
    });
  }
  return oecApp;
};